<template>
    <div id="main-four">
        <img class="absolute bkg-green" height="565px" width="100%" src="@/assets/images/main/Rectangle 555.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute bkg-green-tablet" height="565px" width="100%" src="@/assets/images/main/Rectangle 683.png" v-else>
        <img class="absolute cloud" height="203px" width="52%" src="@/assets/images/main/Vector 14.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute cloud-footer" height="468px" width="46%" src="@/assets/images/main/Vector 13.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute cloud-footer-tablet" height="464px" width="100%" src="@/assets/images/main/Vector 52.png" v-else>
        <img class="absolute robot" src="@/assets/images/main/Group 550.png" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div class="flex-center absolute button" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <HomeButtonEnter class="mr-12 button-blue"/>
            <!-- <HomeButton class="button-blue"/> -->
        </div>
        <div class="absolute point roboto-normal-18 clr-black-5f" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <!-- <div>О Проекте</div>
            <div>FAQ</div> -->
            <div class="pointer" @click="toDataPolitic()">Документы, определяющие политику в отношении обработки персональных данных </div>
            <div class="pointer" @click="toPersonalAgreement()">Согласие на обработку персональных данных, собираемых на сайте</div>
            <div class="pointer" @click="toUserAgreement()">Пользовательское соглашение</div>
            <div class="pointer" @click="toLicense()">Лицензионное соглашение</div>
        </div>
    </div>
</template>

<script>
import HomeButton from './HomeButton.vue'
import HomeButtonEnter from './HomeButtonEnter.vue'
export default {
    name: 'HomeFooter',
    data() {
        return {
            localHost: window.location.href
        }
    },
    components: {
        HomeButton,
        HomeButtonEnter
    },
    methods: {
        toDataPolitic() {
            window.location=`${this.localHost}terms/data_politic_en.html`
        },
        toPersonalAgreement() {
            window.location=`${this.localHost}terms/personal_agreement_en.html`
        },
        toUserAgreement() {
            window.location=`${this.localHost}terms/user_agreement_en.html`
        },
        toLicense() {
            window.location=`${this.localHost}terms/license_en.html`
        }
    },
}
</script>

<style lang="scss" scoped>
$clr-black: #000000;
$clr-white: #FFFFFF;
#main-four {
    .bkg-green {
        top:2627px;
    }
    .bkg-green-tablet {
        top:3165px;
    }
    .cloud {
        top:2577px;
    }
    .cloud-footer {
        top:2724px;
        right:0%;
    }
    .cloud-footer-tablet {
        top:3304px;
    }
    .robot {
        top: 2480px;
        right: 22%;
        &.md, &.sm {
            top:3195px;
            left:11%;
            height:195.85px;
        }
    }
    .button {
        top:2868px;
        right:5%;
        &.lg {
            right:2%;
        }
        &.md, &.sm {
            top:3471px;
            right:10%;
        }
        // .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        //     background: #18A0FB;
        //     box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        //     border-radius: 8px;
        //     font-family: Roboto;
        //     font-style: normal;
        //     font-weight: normal;
        //     font-size: 24px;
        //     line-height: 31px;
        //     text-align: center;
        //     color: $clr-white;
        //     height: 65px;
        //     width: 210px;
        //     letter-spacing: 0.5px
        // }
    }
    .point {
        left:61%;
        top:3012px;
        &.lg {
            top:2962px
        }
        &.md, &.sm {
            top: 3590px;
            left:9%;
        }
        &.sm {
            top: 3560px;
            left:9%;
        }
    }
}
</style>